import React from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {connect} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {useFeature} from 'components/feature';
import {CART_UPGRADE_EDIT} from 'constants/analytics/events/cartUpgrade';
import {PRODUCT_TYPES} from 'constants/product';
import {ApplicationStoreType} from 'desktop/store';

import {getIsCartLoaded} from '../../store/selectors';
import {CartItemType} from '../../types';

import s from './baseEditButton.scss';

export type PropsType = {
    item: CartItemType;
    isReadyForEdit: boolean;
};

const ANALYTICS_EVENT_MAP = {
    [PRODUCT_TYPES.ACCESSORY]: '',
    [PRODUCT_TYPES.CONTACT_LENSES]: 'contacts',
    [PRODUCT_TYPES.EYEGLASSES]: 'glasses',
    [PRODUCT_TYPES.GIFT]: '',
    [PRODUCT_TYPES.SUNGLASSES]: 'glasses',
    [PRODUCT_TYPES.UPGRADE]: '',
};

/**
 * Base item edit button
 * @param {PropsType} props - components props
 * @returns {React.ReactElement} - base item edit button
 */
export const BaseEditButton: React.FC<PropsType> = ({isReadyForEdit, item}) => {
    const navigate = useNavigate();
    const pdpToCartSpaEnabled = useFeature('pdpToCartSpa');
    /**
     * Send analytics on click. Redirect to configure page
     */
    const onEditClick = () => {
        const eventType = ANALYTICS_EVENT_MAP[item.type];

        if (eventType) {
            sendDesktopAnalyticsEvent(CART_UPGRADE_EDIT);
        }

        if (pdpToCartSpaEnabled) {
            navigate(`/checkout/cart/configure/id/${item.id}/${item.product_sku}.html`);
        } else {
            window.location.assign(
                `/checkout/cart/configure/id/${item.id}/${item.product_sku}.html`,
            );
        }
    };

    return (
        <button
            className={s.button}
            data-test-name="edit"
            disabled={!isReadyForEdit}
            onClick={onEditClick}
            type="button"
        >
            Edit
        </button>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    isReadyForEdit: getIsCartLoaded(store),
});

export const BaseEditButtonConnected = connect(mapStateToProps)(BaseEditButton);
